import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class BoBankResponsecodeFilter extends Component {
    state = {
        BoBankResponsecodeLists:[],
        BoBankResponsecodeValue: '',
        isBoBankResponsecodeLoading: true
    };
    componentDidMount(){
        this.getBoBankResponsecode(this.props.start_date,this.props.end_date);
    }
    restBoBankResponsecodeFilter() {
        this.setState({
            BoBankResponsecodeValue: [],
        })
    }
    getBoBankResponsecode(start_date, end_date){
        this.setState({
            BoBankResponsecodeLists:[],
        BoBankResponsecodeValue: [],
        isBoBankResponsecodeLoading: true
        })
        axios.get(config.get('API_URL')+'/filters/bo_bank_responsecode/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                start_date: start_date,
                end_date: end_date
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tender_mode, index) => {
                    this.state.BoBankResponsecodeLists.push({value: tender_mode.bo_bank_responsecode, label: tender_mode.bo_bank_responsecode})
                });
            }
            this.setState({
                isBoBankResponsecodeLoading: false
            })
        });

    }


    changeBoBankResponsecode(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.BoBankResponsecodeLists.findIndex(obj => obj.value==ids.value);
                this.state.BoBankResponsecodeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectBoBankResponsecode(optionSelected, tenderArray);
        this.setState({
            BoBankResponsecodeValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="tender_mode"
                isMulti
                value={this.state.BoBankResponsecodeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeBoBankResponsecode.bind(this)}
                options={this.state.BoBankResponsecodeLists}
                placeholderButtonLabel="Select [Bo Bank Responsecode]"
                isLoading={this.state.isBoBankResponsecodeLoading}
            />
        );

    }
}
export default BoBankResponsecodeFilter;